const md = `# External sharing — invitation-only is coming

For IP protection, **anonymous public share links have been
retired** as of **2026-05-26**.  Every demo video that leaves Eyvo
will now travel through invitation-only email delivery instead.

> *In progress.*  Phase 1 (this release) has retired the legacy
> \`/share/:token\` flow and prepared the database for invitations.
> Phase 2 wires the actual email delivery and the recipient-facing
> player.  Both phases will be shipped without operator action.

## Why we made the change

Public share URLs leak via email forwarding, Slack screenshots,
recruiter outreach, and "send this to the team" group chats.  Once a
URL is out, we can't tell who's watching, can't tell when, can't
limit how often, and can't revoke individuals.  For an external
distribution surface — especially one that shows Eyvo's intellectual
property in motion — that's no longer acceptable.

Invitation-only delivery solves this:

- Every recipient is addressed by **personal email**.
- Each invitation is **single-recipient** and **time-limited** (default
  14-day window with rotating 24h magic-link tokens).
- The demo owner sees a per-view ledger: who opened, who watched,
  how far they got, and whether anyone tried after revoke/expiry.
- Anyone can be **revoked** with a single click; revocation is
  immediate and audited.

## What's available right now (Phase 1)

| Surface | Status |
|---------|--------|
| Anonymous public link \`/share/:token\` | **Retired** — shows a deprecation page. |
| \`GET /api/public/demo/{token}\` | **HTTP 410 Gone** with stable JSON \`error: "public_share_disabled"\`. |
| \`POST /api/demo-runs/{id}/shares\` | **HTTP 410 Gone** — no new public shares can be minted. |
| Operator "Share" button on a run detail page | **Disabled** with tooltip "Invitation-only sharing is coming in the next release." |
| New collections (\`video_invitations\`, \`access_tokens\`, \`video_view_audit\`) | Created with indexes; no rows yet. |

The existing \`demo_shares\` collection rows are preserved untouched
for audit purposes.  An admin can still revoke individual rows via
the existing list/delete endpoints.

## What's coming in Phase 2

- \`POST /api/invitations\` — operator endpoint to invite an email
  (optionally with a company name for personalised watermark).
- Resend-backed transactional email delivery from a verified sender.
- \`/v/:invitation_id\` recipient-facing player route, gated by a
  short-lived magic-link token cookied to the recipient's session.
- Per-invitation audit timeline + immediate revoke control on the
  operator side.
- An \`Invitations\` tab on every Run Detail page replacing the old
  Share button.

We will not ship Phase 2 until DKIM, SPF, and DMARC records are
verified on the sender domain so recipients don't land in spam.

If you have a stale URL from before 2026-05-26, please ask the demo
owner to re-invite you via email.
`;

export default md;
